@let vm = { countries: countries$ | async };
@if (mode() === 'view') {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Passport Number</h5>
                    <span id="passportNum">{{ formGroup().value.number || 'Unspecified' }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Country</h5>
                    <span id="passportCountry">{{
                        formGroup().value.country ? formGroup().value.country : 'Unspecified'
                    }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Passport Issue Date</h5>
                    <span id="passportIssue">{{
                        formGroup().value.issueDate
                            ? (formGroup().value.issueDate.toDate() | dateFormat | uppercase)
                            : 'Unspecified'
                    }}</span>
                </div>
            </div>
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Passport Expiration Date</h5>
                    <span id="passportExpiration">{{
                        formGroup().value.expirationDate
                            ? (formGroup().value.expirationDate.toDate() | dateFormat | uppercase)
                            : 'Unspecified'
                    }}</span>
                </div>
            </div>
        </div>
    </div>
} @else if (mode() === 'edit') {
    <div class="o-grid">
        @for (error of formGroup().errors | keyvalue; track error) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <medpace-alert [appearance]="'danger'" [content]="error.value" />
                </div>
            </div>
        }
        <div class="o-grid__row">
            <div class="o-grid__field half">
                <mds-text-field
                    id="passportNum"
                    [formCtrl]="formGroup().controls.number"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Passport Number"
                    width="100%"
                ></mds-text-field>
            </div>

            <div class="o-grid__field half">
                <mds-autocomplete
                    [closeOnPageScroll]="false"
                    [disableRipple]="false"
                    [formCtrl]="formGroup().controls.country"
                    [options]="vm.countries"
                    appearance="outline"
                    placeholder="Enter country"
                    label="Country"
                    id="passportCountry"
                    [validateInput]="true"
                >
                </mds-autocomplete>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__field half">
                <medpace-datepicker
                    [formCtrl]="formGroup().controls.issueDate"
                    id="passportIssue"
                    appearance="outline"
                    label="Issue Date"
                    [required]="true"
                ></medpace-datepicker>
            </div>

            <div class="o-grid__field half">
                <medpace-datepicker
                    [formCtrl]="formGroup().controls.expirationDate"
                    id="passportExpiration"
                    appearance="outline"
                    label="Expiration Date"
                    [required]="true"
                ></medpace-datepicker>
            </div>
        </div>
    </div>
}
